import { storageService } from './storage.service';

export class SessionStoredItem<Item> {
  public get item() {
    return storageService.getItem<Item>(this.itemKey, 'session');
  }

  public set item(item: Item | undefined) {
    if (item) {
      storageService.setItem(this.itemKey, item, 'session');
    } else {
      storageService.remove(this.itemKey, 'session');
    }
  }

  private itemKey = `${this.key}_${this.moduleVariantId}`;

  public constructor(private moduleVariantId: string, private key: string) {}
}
